/**
 * @fileoverview This file defines a tool for generating code using an LLM. It provides a function and tool definition for use in a larger system.
 */

import { generateCodeWithStreamV2 } from '../generate/generate_v2'
import z from 'zod'
import { ToolDefinition } from '@iterator/shared-node/ai/llm_types'
import { ClaudeSonnetModel } from '@src/ai/models'

export const GenerateCodeArgs = z.object({
  prompt: z.string(),
})

export type GenerateCodeCall = {
  name: 'generateCode'
  args: z.infer<typeof GenerateCodeArgs>
}

export async function generateCode(prompt: string) {
  return await generateCodeWithStreamV2(process.cwd(), prompt, ClaudeSonnetModel, 'documentation')
}

export const generateCodeTool: ToolDefinition = {
  name: 'generateCode',
  function: {
    name: 'generateCode',
    description:
      'Generate code and write it to files. Multiple files can be updated at the same time. Provide a detailed prompt describing code you want to generate and this tool will generate the actual code. It is best practice to include name of the file you want to update or reference.',
    parameters: {
      type: 'object',
      properties: {
        prompt: {
          type: 'string',
          description: 'Detailed description of the code to generate',
        },
      },
      required: ['prompt'],
    },
  },
  execute: async (args: unknown): Promise<string> => {
    const { prompt } = GenerateCodeArgs.parse(args)
    return await generateCode(prompt)
  },
}
